import React from 'react';
import { JoinerEditorTabs, JoinerEditorHeader, JoinerEditorButtons } from '../joinerEditor';
import Edit from '../editForms/edit/ChoiceEdit';
import AttachMedia from '../editForms/media/AttachMedia';
import Options from '../editForms/options/ChoiceOptions';
import Timing from '../editForms/timing/Timing';
import Rules from '../editForms/rules/Rules';

import './ChoiceEditor.css';

class ChoiceEditor extends React.Component {
  render() {
    const { props } = this;
    const { isScreener } = props;
    return (
      <>
        <JoinerEditorTabs
          tabs={props.tabs}
          joinerInfo={props.joinerInfo}
          hideMedia={isScreener}
          hideTiming={isScreener}
        />
        <div className="joiner-editor">
          <JoinerEditorHeader {...props} />
          <div className="joiner-editor-form">
            <Edit {...props} />
            {!isScreener && <AttachMedia {...props} />}
            <Options {...props} />
            <Timing {...props} />
            <Rules {...props} />
          </div>
          <JoinerEditorButtons
            toggle={props.toggle}
            saveEnabled={props.saveEnabled}
            saveJoiner={props.saveJoiner}
            readOnly={props.readOnly}
          />
        </div>
      </>
    );
  }
}

export default ChoiceEditor;
